import { useQuery } from "@tanstack/react-query";

import type { TechnologiesDescriptionDto } from "app/pages/sales-intelligence/domain/technology/types/dto";
import { groupTechnologiesByType } from "app/pages/sales-intelligence/domain/technology/utils/grouping";

import type { TechnologiesListItems } from "../types/technologies";
import { getTechnologiesListItems } from "../utils/technologies";

import { createDescriptionQuery } from "./options";

export const EMPTY_TECHNOLOGIES_LIST_ITEMS: TechnologiesListItems = {
    categories: [],
    subCategories: [],
    technologies: [],
};

const select = ({ technologies }: TechnologiesDescriptionDto): TechnologiesListItems =>
    getTechnologiesListItems(groupTechnologiesByType(technologies));

export default function useTechnologiesListItemsQuery() {
    return useQuery(createDescriptionQuery({ select }));
}
